import createVueComponent from '../createVueComponent';

const Wallet = createVueComponent('WalletIcon', [
  ['path', { d: 'M21 12V7H5a2 2 0 0 1 0-4h14v4', key: '195gfw' }],
  ['path', { d: 'M3 5v14a2 2 0 0 0 2 2h16v-5', key: '195n9w' }],
  ['path', { d: 'M18 12a2 2 0 0 0 0 4h4v-4Z', key: 'vllfpd' }],
]);

export default Wallet;
